import React from 'react';
import { graphql } from 'gatsby';
import SearchProvider from '../components/search';
import StockPage from '../layouts/stock-page';
import '../fragments/stock-page-filters';

export const pageQuery = graphql`
  query ACMVehiclesStockPage($id: ID!, $limit: Int!, $sort: String!, $where: STRAPI_JSON, $withStaticVehicles: Boolean!) {
    strapi {
      vehiclesConnection(where: $where) {
        ...StockPageFilters
        aggregate {
          count
        }
      }
      staticVehicles: vehicles(limit: $limit, sort: $sort, where: $where) @include(if: $withStaticVehicles) {
        id
        ...VehiclePreview
      }
      page(id: $id) {
        id
        title
        content
        ...PagesPageHead
      }
    }
  }
`;

const StockPageTemplate = ({
  pageContext,
  data: {
    strapi: {
      vehiclesConnection,
      staticVehicles,
      page,
    },
  },
}) => (
  <SearchProvider
    staticVehicles={staticVehicles}
    vehiclesConnection={vehiclesConnection}
    limit={pageContext.limit}
    defaultSort={pageContext.sort}
    defaultValues={pageContext.where}
    possibleLayouts={pageContext.possibleLayouts}
    slugPrefix={pageContext.slugPrefix}
    layoutKey={pageContext.title}
  >
    <StockPage page={page} />
  </SearchProvider>
);

export default StockPageTemplate;
